module.exports = __webpack_public_path__ + "img/v2_leaf_right.30fa0484.png";